import recallServices from '../../../../../services/supplier/supplier-recall'
import ActionType from '../../../../../components/part/provider/ActionType'
import { OUTPUT_DATE_FORMAT} from '../../../../../misc/commons'
import { COMMUNICATION_TYPE } from '../../../../../misc/commons'
import ReminderMailModel from './ReminderMailModel'
export default {
    props: {
        communicationId: {type: String, default: null},
        communicationType: {type: String, default: ''},
    },
    components: {
        ActionType,
        ReminderMailModel
    },
    data() {
        return {
            searchQuery: '',
            currentPage: 1,
            perPage: 20,
            pageOptions: [20, 50, 100, 500],
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            communicationTypeForRecall: COMMUNICATION_TYPE.RECALL,
            viewBy: null,
            allOpenRows: [],
            // --- Selection Data ---
            selectedProviders: [], // Stores composite keys: "providerId-recallsiteId" (e.g., "123-10")
            selectAll: false,
            // ---------------------------
            allOpenactionListRows: [],
            providerList_Detailschild: [],
            actionList_DetailsChild: [],
            actionList: [],
            actionList_Details: [],
            selectedActionId: null,
            actionListFields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                },
                {
                    key: 'progress',
                    label: 'Progress',
                    class: 'text-center',
                    thStyle: { width: '60px' },
                    sortable: true,
                }
            ],
            actionList_Details_Recalls_Fields: [

                {
                    key: 'provider_name',
                    label: 'Provider',
                    sortable: true
                },
                {
                    key: 'account_type',
                    label: 'Account Type',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { width: '125px' },
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                },
                {
                    key: 'isExpanded',
                    label: '',
                    sortable: false,
                }
            ],
            actionList_Details_Disruptions_Fields: [

                {
                    key: 'provider_name',
                    label: 'Provider',
                    sortable: true
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                },
                {
                    key: 'isExpanded',
                    label: '',
                    sortable: false,
                }
            ],
            actionList_Details_Recalls_FieldsChild: [

                {
                    key: 'actionDesc',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'account_type',
                    label: 'Account Type',
                    sortable: true,
                    class: 'text-center',
                    thStyle: { width: '125px' },
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                },
            ],
            actionList_Details_Disruptions_FieldsChild: [

                {
                    key: 'actionDesc',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                },
            ],
            providerList: [],
            allCompletedProviderList: false,
            providerList_Details: [],
            selectedProviderId: null,
            selectedProviderRecallId: null,
            remindermailModelKey: 0,
            providerListFields: [
                {
                    key: 'name',
                    label: 'Provider',
                    sortable: true
                },
                {
                    key: 'numberOfLocations',
                    label: '# of Locations',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: false,
                    thStyle: { width: '60px' },
                },
                {
                    key: 'completed',
                    label: '',
                    class: 'text-center',
                    thStyle: { width: '60px' },
                    sortable: true,
                },
                {
                    key: 'selected',
                    label: 'Select Providers',
                    class: 'text-center',
                    thClass: 'text-center',
                    thStyle: { width: '40px' },
                    sortable: false
                },
            ],
            providerList_Details_Fields: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                },
                {
                    key: 'isExpanded',
                    label: '',
                    sortable: false,
                }
            ],
            providerList_Details_Fieldschild: [
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true,
                    tdClass: 'DescriptioncolClass',
                },
                {
                    key: 'data',
                    label: 'Response',
                    sortable: true,
                    tdClass: 'responsecolClass',
                },
                {
                    key: 'modified_at',
                    label: 'Last Modified',
                    sortable: true,
                    tdClass: 'modifiedcolClass',
                },
                {
                    key: 'name',
                    label: 'User',
                    sortable: true,
                    tdClass: 'usercolClass',
                },
            ],

            PROVIDER_RECALL_STATUS: [
                { value: 'OPEN', text: 'In Progress', color: '#ffc107' },
                { value: 'COMPLETED', text: 'Completed', color: '#28a745' },
            ]
        }
    },
    created(){
        this.$emit('onReLoadCommunicationData')
    },
    mounted() {
        this.viewBy = 'Provider'
    },
    computed: {
        filteredProviderList() {
            let filtered = this.providerList
            if (this.searchQuery) {
                const lower = this.searchQuery.toLowerCase()
                filtered = filtered.filter(p => p.name && p.name.toLowerCase().includes(lower))
            }
            return filtered
        },
        totalProviders() {
            return this.filteredProviderList.length
        },
        paginatedProviderList() {
            // Return only providers for the current page
            const start = (this.currentPage - 1) * this.perPage
            const end = start + this.perPage
            return this.filteredProviderList.slice(start, end)
        },
        availableStatuses() {
            // Extract unique statuses from providerList
            const statuses = new Set()
            this.providerList.forEach(provider => {
                if (provider.status) {
                    statuses.add(provider.status)
                }
            })
            return Array.from(statuses).sort().map(status => ({
                value: status,
                text: status.replace(/_/g, ' ')
            }))
        }
    },
    watch: {
        providerList: {
            handler() {
                this.updateSelectAllState()
            },
            deep: true
        },
        selectedProviders() {
            this.updateSelectAllState()
        },
        currentPage() {
            // Clear all selections when page changes
            this.selectedProviders = []
            this.selectAll = false
            // Select first provider on the new page
            this.$nextTick(() => {
                if (this.paginatedProviderList && this.paginatedProviderList.length > 0 && this.paginatedProviderList[0].provider_id) {
                    this.selectedProviderId = this.paginatedProviderList[0].provider_id
                    this.selectedProviderRecallId = this.paginatedProviderList[0].providerCommunicationId
                    this.GetRecallAction_ProviderListing_Detail()
                } else {
                    // No records on this page - reset selection and clear actions
                    this.selectedProviderId = null
                    this.selectedProviderRecallId = null
                    this.providerList_Details = []
                    this.providerList_Detailschild = []
                }
            })
        },
        searchQuery() {
            this.currentPage = 1
            this.selectedProviders = []
            this.selectAll = false
            // Always handle first record selection or reset after search
            this.$nextTick(() => {
                if (this.paginatedProviderList && this.paginatedProviderList.length > 0 && this.paginatedProviderList[0].provider_id) {
                    // Records found - show first record actions
                    this.selectedProviderId = this.paginatedProviderList[0].provider_id
                    this.selectedProviderRecallId = this.paginatedProviderList[0].providerCommunicationId
                    this.GetRecallAction_ProviderListing_Detail()
                } else {
                    // No records found - reset selection and clear actions
                    this.selectedProviderId = null
                    this.selectedProviderRecallId = null
                    this.providerList_Details = []
                    this.providerList_Detailschild = []
                }
            })
        },
        perPage() {
            // When page size changes, select first record on current page
            this.$nextTick(() => {
                if (this.paginatedProviderList && this.paginatedProviderList[0] && this.paginatedProviderList[0].provider_id) {
                    this.selectedProviderId = this.paginatedProviderList[0].provider_id
                    this.selectedProviderRecallId = this.paginatedProviderList[0].providerCommunicationId
                    this.GetRecallAction_ProviderListing_Detail()
                }
            })
        },
        viewBy(val) {
            // Reset pagination when switching tabs
            this.currentPage = 1
            this.selectedProviders = []
            this.selectAll = false
            if (val == 'Action') {
                this.GetRecallAction()
            } else
            if (val == 'Provider') {
                this.GetRecallAction_ProviderListing()
            }
        }
    },
    methods: {
        handleRowClicked(item, index) {
            if(item.isCustomizedContent)
            {
                item.isExpanded=item.isCustomizedContent ?!item.isExpanded:item.isExpanded
            }
            if(item.isCustomizedContent)
            {
                this.allOpenRows.map((ele) => {
                    if (ele.id !== item.id && ele._showDetails) {
                        this.$set(ele, '_showDetails', !ele._showDetails)
                    }
                })
                this.allOpenRows = []
                this.$set(item, '_showDetails', !item._showDetails)
                this.allOpenRows.push(item)
            }
        },
        handleRowClickedActionList(item)
        {
            if(item.isCustomizedContent  && item.baseActionId==0)
            {
                item.isExpanded=item.isCustomizedContent ?!item.isExpanded:item.isExpanded
                this.allOpenactionListRows.map((ele) => {
                    if (ele.id !== item.id && ele._showDetails) {
                        this.$set(ele, '_showDetails', !ele._showDetails)
                    }
                })
                this.allOpenactionListRows = []
                this.$set(item, '_showDetails', !item._showDetails)
                this.allOpenactionListRows.push(item)
            }
        },
        SendReminderMail() {
            this.remindermailModelKey += 1
            this.$nextTick(() => {
                this.$refs.remindermailModel.forceRerenderView(
                    null,
                    this.communicationId,
                    'SendMail',
                    this.providerCommunicationId == undefined ? this.$route.params.providerCommunicationId : this.providerCommunicationId,
                    this.communicationType
                )
            })
        },
        SendReminderLocation() {
            if (this.selectedProviders.length === 0) {
                this._showToast('Please select at least one provider.', { variant: 'warning' })
                return
            }
            // Build list of objects from composite keys (format: "providerId-siteId")
            const selectedProviderObjects = this.selectedProviders.map(compositeKey => {
                const [providerId, recallSiteId] = compositeKey.split('-').map(Number)
                return { providerId, recallSiteId }
            })
            // Call sendNotification API with REMINDER_EMAIL as sendType
            recallServices.sendNotification(
                this.communicationId,           // communicationId
                'REMINDER_EMAIL',               // sendType
                this.communicationType,         // communicationType
                null,                          // notificationDate
                null,                          // selectedNonCoveredSendNotification
                null,                          // sendNewOrganizationIds
                selectedProviderObjects,       // selectedProviders
                null                           // selectedReminderStatuses
            ).then(resp => {
                if (!resp.error) {
                    this._showToast('Reminder email sent successfully!', { variant: 'success' })
                    this.selectedProviders = []
                    this.selectAll = false
                    this.GetRecallAction_ProviderListing()
                } else {
                    this._showToast('Failed to send reminder email.', { variant: 'danger' })
                }
            })
        },
        SendReminderStatus() {
            this.remindermailModelKey += 1
            this.$nextTick(() => {
                this.$refs.remindermailModel.forceRerenderView(
                    null,
                    this.communicationId,
                    'Status',
                    this.providerCommunicationId == undefined ? this.$route.params.providerCommunicationId : this.providerCommunicationId,
                    this.communicationType,
                    this.providerList, // Pass full provider list
                    this.availableStatuses // Pass available statuses for dropdown
                )
            })
        },
        rowTableProviderClick(item) {
            this.selectedProviderId = item.provider_id
            // updated this from providerId to providerCommunicationId because a provider may have multiple
            this.selectedProviderRecallId = item.providerCommunicationId
            this.GetRecallAction_ProviderListing_Detail()
        },
        getCompositeKey(provider) {
            // Create composite key from provider_id and recallsiteid
            return `${provider.provider_id}-${provider.recallsiteid}`
        },
        toggleSelectAll(checked) {
            this.selectAll = checked
            if (checked) {
                // Select only non-completed providers on current page
                this.selectedProviders = this.paginatedProviderList
                    .filter(p => p.status !== 'COMPLETED')
                    .map(p => this.getCompositeKey(p))
            } else {
                // Clear all selections
                this.selectedProviders = []
            }
        },
        toggleProviderSelection(compositeKey) {
            const index = this.selectedProviders.indexOf(compositeKey)
            if (index > -1) {
                this.selectedProviders.splice(index, 1)
            } else {
                this.selectedProviders.push(compositeKey)
            }
        },
        updateSelectAllState() {
            // Only consider non-completed providers on current page for select all state
            const selectableProviders = this.paginatedProviderList?.filter(p => p.status !== 'COMPLETED')
            if (selectableProviders.length === 0) {
                this.selectAll = false
            } else {
                this.selectAll = selectableProviders?.every(p => this.selectedProviders.includes(this.getCompositeKey(p)))
            }
        },
        // ------------------------------
        rowTableActionClick(item) {
            this.selectedActionId = item.action_id
            this.GetRecallAction_Detail()
        },
        rowClassProvider(item, type) {
            if (!item || type !== 'row') return
            if (item.provider_id === this.selectedProviderId && item.providerCommunicationId === this.selectedProviderRecallId) return 'table-primary'
        },
        rowClassAction(item, type) {
            if (!item || type !== 'row') return
            if (item.action_id === this.selectedActionId) return 'table-primary'
        },
        GetRecallAction () {
            recallServices.GetRecallAction(this.communicationId).then(resp => {
                if (!resp.error) {
                    this.actionList = resp.data.d
                    if (this.actionList && this.actionList[0] && this.actionList[0].action_id){
                        this.selectedActionId = this.actionList[0].action_id
                        this.GetRecallAction_Detail()
                    }
                }
            })
        },
        GetRecallAction_Detail () {
            recallServices.GetRecallAction_Detail(this.communicationId, this.selectedActionId).then(resp => {
                if (!resp.error) {
                    this.actionList_Details = resp.data.d.filter(s=>s.baseActionId==0)
                    this.actionList_DetailsChild =resp.data.d.filter(s=>s.baseActionId>0)
                    this.actionList_Details.forEach(item => {
                        if(!item.isCustomizedContent)
                        {
                            if (item.data.valueSingleChoice == undefined && item.data.valueNumeric == undefined && item.data.valueMultiChoice == undefined && item.data.valueAcknowledge == undefined && item.data.valueYesNo == undefined && item.data.valueText == undefined && item.data.valueImage == undefined && item.data.valueDocument == undefined && item.data.valueCheckbox == undefined && item.type != 'Acknowledge') {
                                item.account_type = null
                            }
                        }
                        else
                        {
                            let isResponded = false
                            let child= this.actionList_DetailsChild.filter(s=>s.provider_id==item.provider_id && s.providerCommunicationId ==  item.providerCommunicationId)
                            child.forEach(childitem => {
                                if (childitem.data.valueSingleChoice == undefined && childitem.data.valueNumeric == undefined && childitem.data.valueMultiChoice == undefined && childitem.data.valueAcknowledge == undefined && childitem.data.valueYesNo == undefined && childitem.data.valueText == undefined && childitem.data.valueImage == undefined && childitem.data.valueDocument == undefined && childitem.data.valueCheckbox == undefined) {
                                    childitem.account_type = null
                                }
                                else
                                {
                                    isResponded = true
                                }
                            })
                            if(!isResponded && item.type != 'Acknowledge')
                            {
                                item.account_type = null
                            }
                        }
                    })
                }
            })
        },
        GetRecallAction_ProviderListing () {
            recallServices.GetRecallAction_ProviderListing(this.communicationId).then(resp => {
                if (!resp.error) {
                    this.providerList = resp.data.d
                    if (this.providerList && this.providerList[0] && this.providerList[0].provider_id){
                        this.selectedProviderId = this.providerList[0].provider_id

                        this.selectedProviderRecallId = this.providerList[0].providerCommunicationId
                        this.GetRecallAction_ProviderListing_Detail()
                    }
                    this.allCompletedProviderList = this.providerList.every(item => item.status === 'COMPLETED')
                }
            })
        },
        GetRecallAction_ProviderListing_Detail () {

            recallServices.GetRecallAction_ProviderListing_Detail(this.communicationId, this.selectedProviderId,this.selectedProviderRecallId).then(resp => {
                if (!resp.error) {
                    var actions=[]
                    resp.data.d.filter(s=>s.baseActionId==0).forEach((action) => {
                        if(action.isCustomizedContent==false)
                        {
                            actions.push(action)
                        }
                        else{
                            let clidlActions = resp.data.d.filter(x => x.baseActionId == action.action_id)
                            if(clidlActions.length>0)
                            {
                                actions.push(action)
                            }
                        }

                    })
                    this.providerList_Details = this.paginatedProviderList .length > 0 ? actions : []
                    this.providerList_Detailschild=resp.data.d.filter(s=>s.baseActionId>0)
                }
            })
        },
        exportproviderstausReport() {
            recallServices.getRecallById(this.communicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'supp_Recall' })
                } else {
                    recallServices.exportproviderstausReport(this.communicationId, resp.data.d.communicationUID)
                }
            })
        },
        downloadproviderstausReport() {
            recallServices.getRecallById(this.communicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'supp_Recall' })
                } else {
                    recallServices.downloadproviderstausReport(this.communicationId, resp.data.d.communicationUID)
                }
            })
        },
        exportproviderLocationstausReport(){
            recallServices.getRecallById(this.communicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'supp_Recall' })
                } else {
                    recallServices.exportproviderLocationstausReport(this.communicationId, resp.data.d.communicationUID)
                }
            })
        },
        downloadproviderLocationstausReport() {
            recallServices.getRecallById(this.communicationId).then(resp => {
                if (resp.error) {
                    this.$router.push({ name: 'supp_Recall' })
                } else {
                    recallServices.downloadproviderLocationstausReport(this.communicationId, resp.data.d.communicationUID)
                }
            })
        },

    }
}